import { FSharpRef, toString as toString_1, Record, Union } from "../fable_modules/fable-library.4.1.4/Types.js";
import { lambda_type, record_type, list_type, tuple_type, int32_type, option_type, union_type, string_type } from "../fable_modules/fable-library.4.1.4/Reflection.js";
import { Status, Combatant__is_Z625EB0E9, Combatant__get_CurrentHP_, calibrate, FightResult, specificFight, DefeatCriteria, FightResult_$reflection, DefeatCriteria_$reflection } from "../Domain/FightExecution.fs.js";
import { Core_Creature__get_PluralName_, Core_Creature__get_AlteredTimeRate_, Core_Creature__get_ExtraParry_, Core_Creature__get_ExtraAttack_, Core_DamageType, Core_Creature__get_WeaponSkill_, Core_Creature__get_Dodge_, Core_Creature__get_Speed_, Core_Creature__get_HP_, Core_InjuryTolerance, Core_Creature__get_DR_, Core_Creature__get_HT_, Core_Creature__get_IQ_, Core_Creature__get_DX_, Core_Creature__get_ST_, Parser_$007CCreature$007C_$007C, Core_SelfControlLevel, Core_SelfControlLevel_get_toDescription, Parser_$007CDamageType$007C_$007C, Core_Creature_create_27AED5E3, Parser_$007CDamageOverall$007C_$007C, Core_Creature, Core_Creature__get_Damage_, Core_MonsterDatabase, Core_MonsterDatabase_add, Core_Creature_$reflection, Core_MonsterDatabase_$reflection } from "../Domain/Domain.fs.js";
import { tail, head, append as append_1, filter as filter_1, contains, tryFindIndex, mapIndexed, tryFindIndexBack, item, map as map_1, sort, isEmpty, singleton as singleton_2, last, tryFind as tryFind_1, exists, length, take, ofSeq, sumBy, ofArray, empty } from "../fable_modules/fable-library.4.1.4/List.js";
import { String_oxfordJoin, thunk2, shouldntHappen, Tuple2_create, String_join, toString, thunk1, String_isntWhitespace } from "../Core/Common.fs.js";
import { Catalog_read, Catalog_write } from "./LocalStorage.fs.js";
import { curry3, compareArrays, comparePrimitives, safeHash, createObj, equals } from "../fable_modules/fable-library.4.1.4/Util.js";
import { newGuid } from "../fable_modules/fable-library.4.1.4/Guid.js";
import { sleep, startImmediate } from "../fable_modules/fable-library.4.1.4/Async.js";
import { singleton } from "../fable_modules/fable-library.4.1.4/AsyncBuilder.js";
import { unwrap, orElse, value as value_85, defaultArg } from "../fable_modules/fable-library.4.1.4/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { React_createDisposable_3A5B6456 as React_createDisposable_3A5B6456_1, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.2.4.0/React.fs.js";
import { collect, sortBy, empty as empty_1, map, filter, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library.4.1.4/Seq.js";
import { classTxt$0027, class$0027, classP$0027 } from "./CommonUI.fs.js";
import { printf, isNullOrWhiteSpace, interpolate, toText, startsWith } from "../fable_modules/fable-library.4.1.4/String.js";
import { FSharpMap__get_Item, FSharpMap__get_Values, tryFind, FSharpMap__get_Keys } from "../fable_modules/fable-library.4.1.4/Map.js";
import { Interop_reactApi } from "../fable_modules/Feliz.2.4.0/./Interop.fs.js";
import { tryParse as tryParse_1, min as min_5 } from "../fable_modules/fable-library.4.1.4/Double.js";
import { $007CEnd$007C_$007C, ParseArgs_Init_E827B83 } from "../Core/Packrat.fs.js";
import { tryParse } from "../fable_modules/fable-library.4.1.4/Int32.js";
import { Parser_$007CRoll$007C_$007C } from "../Domain/Random.fs.js";
import { React_createDisposable_3A5B6456, useReact_useCallbackRef_7C4B0DD6, useReact_useEffect_Z5ECA432F, useReact_useMemo_10C6A43C } from "../fable_modules/Feliz.UseListener.0.6.3/../Feliz.2.4.0/React.fs.js";
import { Impl_createRemoveOptions, Impl_adjustPassive } from "../fable_modules/Feliz.UseListener.0.6.3/./Listener.fs.js";
import { List_distinct } from "../fable_modules/fable-library.4.1.4/Seq2.js";
import { rangeDouble } from "../fable_modules/fable-library.4.1.4/Range.js";
import { ProgramModule_run } from "../fable_modules/Fable.Elmish.HMR.7.0.0/../Fable.Elmish.4.0.0/program.fs.js";
import { Program_withReactBatched } from "../fable_modules/Fable.Elmish.HMR.7.0.0/../Fable.Elmish.React.4.0.0/react.fs.js";
import { ProgramModule_mkProgram, ProgramModule_withSubscription } from "../fable_modules/Fable.Elmish.4.0.0/program.fs.js";
import "../sass/main.sass";


export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "Editing"];
    }
}

export function Page_$reflection() {
    return union_type("UI.App.Page", [], Page, () => [[], [["name", string_type]]]);
}

export class Opposition extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Calibrate", "Specific"];
    }
}

export function Opposition_$reflection() {
    return union_type("UI.App.Opposition", [], Opposition, () => [[["Item1", option_type(string_type)], ["Item2", option_type(int32_type)], ["Item3", option_type(int32_type)], ["Item4", DefeatCriteria_$reflection()]], [["Item", list_type(tuple_type(int32_type, string_type))]]]);
}

export class FightSetup extends Record {
    constructor(sideA, sideB) {
        super();
        this.sideA = sideA;
        this.sideB = sideB;
    }
}

export function FightSetup_$reflection() {
    return record_type("UI.App.FightSetup", [], FightSetup, () => [["sideA", list_type(tuple_type(int32_type, string_type))], ["sideB", Opposition_$reflection()]]);
}

export class Awaitable$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotStarted", "InProgress", "Completed"];
    }
}

export function Awaitable$1_$reflection(gen0) {
    return union_type("UI.App.Awaitable`1", [gen0], Awaitable$1, () => [[], [], [["Item", gen0]]]);
}

export class Model extends Record {
    constructor(error, page, fightSetup, database, execution) {
        super();
        this.error = error;
        this.page = page;
        this.fightSetup = fightSetup;
        this.database = database;
        this.execution = execution;
    }
}

export function Model_$reflection() {
    return record_type("UI.App.Model", [], Model, () => [["error", option_type(string_type)], ["page", Page_$reflection()], ["fightSetup", FightSetup_$reflection()], ["database", Core_MonsterDatabase_$reflection()], ["execution", Awaitable$1_$reflection(tuple_type(FightSetup_$reflection(), FightResult_$reflection()))]]);
}

export class Side extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SideA", "SideB"];
    }
}

export function Side_$reflection() {
    return union_type("UI.App.Side", [], Side, () => [[], []]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ClearError", "Error", "ChangeFight", "Clear", "Upsert", "SetPage", "Fight"];
    }
}

export function Msg_$reflection() {
    return union_type("UI.App.Msg", [], Msg, () => [[], [["Item", string_type]], [["Item", lambda_type(FightSetup_$reflection(), FightSetup_$reflection())]], [["Item", Side_$reflection()]], [["Item", Core_Creature_$reflection()]], [["Item", Page_$reflection()]], [["Item", Awaitable$1_$reflection(tuple_type(FightSetup_$reflection(), FightResult_$reflection()))]]]);
}

export function update(msg, model) {
    switch (msg.tag) {
        case 5:
            return [new Model(model.error, msg.fields[0], model.fightSetup, model.database, model.execution), empty()];
        case 1:
            return [new Model(msg.fields[0], model.page, model.fightSetup, model.database, model.execution), empty()];
        case 0:
            return [new Model(void 0, model.page, model.fightSetup, model.database, model.execution), empty()];
        case 3:
            return [new Model(model.error, model.page, (msg.fields[0].tag === 1) ? (new FightSetup(model.fightSetup.sideA, new Opposition(0, [void 0, void 0, void 0, new DefeatCriteria(0, [])]))) : (new FightSetup(empty(), model.fightSetup.sideB)), model.database, model.execution), empty()];
        case 4: {
            const creature = msg.fields[0];
            if (String_isntWhitespace(creature.name)) {
                const db = Core_MonsterDatabase_add(creature, model.database);
                Catalog_write(db.catalog);
                return [new Model(model.error, model.page, model.fightSetup, db, model.execution), empty()];
            }
            else {
                return [model, empty()];
            }
        }
        case 6:
            return [new Model(model.error, model.page, model.fightSetup, model.database, msg.fields[0]), empty()];
        default:
            return [new Model(model.error, model.page, msg.fields[0](model.fightSetup), model.database, model.execution), empty()];
    }
}

export function init() {
    let catalog;
    return [new Model(void 0, new Page(0, []), new FightSetup(ofArray([[3, "Peshkali"], [1, "Slugbeast"]]), new Opposition(0, ["Orc", void 0, void 0, new DefeatCriteria(0, [])])), new Core_MonsterDatabase((catalog = Catalog_read(), catalog)), new Awaitable$1(0, [])), empty()];
}

export function beginFights(model, dispatch) {
    if (equals(model.execution, new Awaitable$1(1, []))) {
    }
    else {
        const g = newGuid();
        dispatch(new Msg(6, [new Awaitable$1(1, [])]));
        const value_2 = startImmediate(singleton.Delay(() => singleton.Bind(sleep(100), () => {
            let tupledArg;
            const matchValue = model.fightSetup.sideB;
            if (sumBy((tuple) => tuple[0], model.fightSetup.sideA, {
                GetZero: () => 0,
                Add: (x, y) => (x + y),
            }) === 0) {
                dispatch(new Msg(6, [new Awaitable$1(0, [])]));
                dispatch(new Msg(1, ["You have to pick monsters first"]));
                return singleton.Zero();
            }
            else if (matchValue.tag === 1) {
                dispatch(new Msg(6, [new Awaitable$1(2, [[model.fightSetup, (tupledArg = specificFight(model.database.catalog, model.fightSetup.sideA, matchValue.fields[0]), new FightResult(1, [tupledArg[0], tupledArg[1]]))]])]));
                return singleton.Zero();
            }
            else if (matchValue.fields[0] != null) {
                const name = matchValue.fields[0];
                const matchValue_1 = calibrate(model.database.catalog, model.fightSetup.sideA, name, defaultArg(matchValue.fields[1], 50) / 100, defaultArg(matchValue.fields[2], 90) / 100, matchValue.fields[3]);
                if (matchValue_1[2] != null) {
                    dispatch(new Msg(6, [new Awaitable$1(2, [[model.fightSetup, new FightResult(0, [matchValue_1[0], matchValue_1[1], matchValue_1[2]])]])]));
                    return singleton.Zero();
                }
                else {
                    dispatch(new Msg(6, [new Awaitable$1(0, [])]));
                    dispatch(new Msg(1, ["Failed to find a number of monsters that would satisfy those constraints. Try a wider range like 20% to 100%"]));
                    return singleton.Zero();
                }
            }
            else {
                dispatch(new Msg(6, [new Awaitable$1(0, [])]));
                dispatch(new Msg(1, ["You have to pick monsters first"]));
                return singleton.Zero();
            }
        })));
    }
}

export function MonsterPicker(monsterPickerInputProps) {
    const monsterDetails = monsterPickerInputProps.monsterDetails;
    const dispatch = monsterPickerInputProps.dispatch;
    const side = monsterPickerInputProps.side;
    const onClick = monsterPickerInputProps.onClick;
    const clickLabel = monsterPickerInputProps.clickLabel;
    const noMonstersSelectedYet = monsterPickerInputProps.noMonstersSelectedYet;
    const db = monsterPickerInputProps.db;
    const patternInput = useFeliz_React__React_useState_Static_1505("");
    const namePrefix = patternInput[0];
    const children_2 = toList(delay(() => {
        let value_2;
        return append(singleton_1(createElement("input", createObj(ofArray([["placeholder", "Monster name"], (value_2 = namePrefix, ["ref", (e) => {
            if (!(e == null) && !equals(e.value, value_2)) {
                e.value = value_2;
            }
        }]), ["onChange", (ev) => {
            patternInput[1](ev.target.value);
        }]])))), delay(() => append(singleton_1(classP$0027("newButton", (arg) => createElement("button", createObj(arg)), ofArray([["children", "New"], ["onClick", (arg20$0040) => {
            thunk1(dispatch, new Msg(5, [new Page(1, [""])]), arg20$0040);
        }]]))), delay(() => append(singleton_1(classP$0027("clearButton", (arg_2) => createElement("button", createObj(arg_2)), ofArray([["children", "Clear"], ["onClick", (arg20$0040_1) => {
            thunk1(dispatch, new Msg(3, [side]), arg20$0040_1);
        }]]))), delay(() => append(singleton_1(monsterDetails), delay(() => {
            if ((namePrefix.length > 0) ? true : noMonstersSelectedYet) {
                const matchingNames = ofSeq(filter((name_6) => startsWith(name_6, namePrefix, 3), FSharpMap__get_Keys(db.catalog)));
                return map((name_7) => {
                    const children = ofArray([createElement("button", {
                        children: clickLabel,
                        onClick: (_arg) => {
                            onClick(name_7);
                        },
                    }), name_7]);
                    return createElement("div", {
                        children: Interop_reactApi.Children.toArray(Array.from(children)),
                    });
                }, take(min_5(10, length(matchingNames)), matchingNames));
            }
            else {
                return empty_1();
            }
        }))))))));
    }));
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    });
}

export function checkbox(ctor, label, isChecked, update_1) {
    return ctor(toList(delay(() => {
        const chkid = `checkbox_${label}`;
        return append(singleton_1(createElement("label", {
            children: label,
            htmlFor: chkid,
        })), delay(() => singleton_1(createElement("input", {
            type: "checkbox",
            id: chkid,
            checked: isChecked,
            readOnly: true,
            onChange: (ev) => {
                update_1(ev.target.checked);
            },
        }))));
    })));
}

export function labeled(label, inner) {
    return createElement("div", {
        children: Interop_reactApi.Children.toArray([label, inner]),
    });
}

export function EditData(editDataInputProps) {
    const update_1 = editDataInputProps.update;
    const value = editDataInputProps.value;
    const hint = editDataInputProps.hint;
    const label = editDataInputProps.label;
    const parser = editDataInputProps.parser;
    const render = editDataInputProps.render;
    const propType = editDataInputProps.propType;
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const setEditing = patternInput[1];
    const liveValue = (value == null) ? "" : render(value_85(value));
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(liveValue);
    const updateTxt = patternInput_1[1];
    const txt = patternInput_1[0];
    return labeled(label, createElement("input", createObj(toList(delay(() => {
        let value_1;
        return append(singleton_1((value_1 = (patternInput[0] ? txt : liveValue), ["ref", (e) => {
            if (!(e == null) && !equals(e.value, value_1)) {
                e.value = value_1;
            }
        }])), delay(() => append(singleton_1(["placeholder", render(hint)]), delay(() => append(singleton_1(propType), delay(() => append(equals(propType, ["type", "number"]) ? singleton_1(["max", 99]) : empty_1(), delay(() => append(singleton_1(["onChange", (ev) => {
            updateTxt(ev.target.value);
        }]), delay(() => append(singleton_1(["onFocus", (_arg) => {
            setEditing(true);
        }]), delay(() => singleton_1(["onBlur", (_arg_1) => {
            const v_1 = parser(txt);
            update_1(v_1);
            setEditing(false);
            if (v_1 == null) {
                updateTxt("");
            }
            else {
                updateTxt(render(value_85(v_1)));
            }
        }])))))))))))));
    })))));
}

export function EditDataNoHint(editDataNoHintInputProps) {
    const update_1 = editDataNoHintInputProps.update;
    const value = editDataNoHintInputProps.value;
    const label = editDataNoHintInputProps.label;
    const parser = editDataNoHintInputProps.parser;
    const render = editDataNoHintInputProps.render;
    const propType = editDataNoHintInputProps.propType;
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const setEditing = patternInput[1];
    const liveValue = (value == null) ? "" : render(value_85(value));
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(liveValue);
    const updateTxt = patternInput_1[1];
    const txt = patternInput_1[0];
    return labeled(label, createElement("input", createObj(toList(delay(() => {
        let value_1;
        return append(singleton_1((value_1 = (patternInput[0] ? txt : liveValue), ["ref", (e) => {
            if (!(e == null) && !equals(e.value, value_1)) {
                e.value = value_1;
            }
        }])), delay(() => append(singleton_1(propType), delay(() => append(equals(propType, ["type", "number"]) ? singleton_1(["max", 99]) : empty_1(), delay(() => append(singleton_1(["onChange", (ev) => {
            updateTxt(ev.target.value);
        }]), delay(() => append(singleton_1(["onFocus", (_arg) => {
            setEditing(true);
        }]), delay(() => singleton_1(["onBlur", (_arg_1) => {
            const v_1 = parser(txt);
            update_1(v_1);
            setEditing(false);
            if (v_1 == null) {
                updateTxt("");
            }
            else {
                updateTxt(render(value_85(v_1)));
            }
        }])))))))))));
    })))));
}

export function EditDropdown(editDropdownInputProps) {
    const update_1 = editDropdownInputProps.update;
    const options = editDropdownInputProps.options;
    const value = editDropdownInputProps.value;
    const defaultOption = editDropdownInputProps.defaultOption;
    const label = editDropdownInputProps.label;
    const parser = editDropdownInputProps.parser;
    const render = editDropdownInputProps.render;
    return labeled(label, createElement("select", createObj(toList(delay(() => {
        let value_2, value_4;
        return append((value != null) ? singleton_1((value_2 = render(value_85(value)), ["ref", (e) => {
            if (!(e == null) && !equals(e.value, value_2)) {
                e.value = value_2;
            }
        }])) : ((defaultOption != null) ? singleton_1((value_4 = defaultOption, ["ref", (e_1) => {
            if (!(e_1 == null) && !equals(e_1.value, value_4)) {
                e_1.value = value_4;
            }
        }])) : (empty_1())), delay(() => {
            let elems;
            return append(singleton_1((elems = toList(delay(() => {
                let matchValue_1, v, v_1;
                return append((matchValue_1 = defaultOption, (matchValue_1 != null) ? (((v = matchValue_1, !exists((o) => (render(o) === v), options))) ? ((v_1 = matchValue_1, singleton_1(createElement("option", {
                    children: v_1,
                    value: v_1,
                })))) : (empty_1())) : (empty_1())), delay(() => map((option) => createElement("option", {
                    children: render(option),
                    value: render(option),
                }), options)));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])), delay(() => singleton_1(["onChange", (ev) => {
                update_1(parser(ev.target.value));
            }])));
        }));
    })))));
}

export function EditDamage(editDamageInputProps) {
    const update_1 = editDamageInputProps.update;
    const stats = editDamageInputProps.stats;
    const label = editDamageInputProps.label;
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const setEditing = patternInput[1];
    const render = toString;
    let liveValue;
    const matchValue = stats.Damage;
    liveValue = ((matchValue == null) ? "" : render(matchValue));
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(liveValue);
    const updateTxt = patternInput_1[1];
    const txt = patternInput_1[0];
    return class$0027("editDamage", (arg) => createElement("div", createObj(arg)), toList(delay(() => append(singleton_1(label), delay(() => {
        let value_1;
        return append(singleton_1(createElement("input", createObj(ofArray([(value_1 = (patternInput[0] ? txt : liveValue), ["ref", (e) => {
            if (!(e == null) && !equals(e.value, value_1)) {
                e.value = value_1;
            }
        }]), ["placeholder", toString(Core_Creature__get_Damage_(stats))], ["onFocus", (_arg) => {
            setEditing(true);
        }], ["onChange", (ev) => {
            updateTxt(ev.target.value);
        }], ["onBlur", (_arg_1) => {
            let tupledArg;
            const matchValue_1 = ParseArgs_Init_E827B83(txt);
            let matchResult, dmg, dtype;
            const activePatternResult = Parser_$007CDamageOverall$007C_$007C(matchValue_1);
            if (activePatternResult != null) {
                if (((tupledArg = activePatternResult[1], $007CEnd$007C_$007C(tupledArg[0], tupledArg[1]))) != null) {
                    matchResult = 0;
                    dmg = activePatternResult[0][0];
                    dtype = activePatternResult[0][1];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    update_1(new Core_Creature(stats.name, stats.pluralName, stats.ST, stats.DX, stats.IQ, stats.HT, stats.HP, stats.DR, stats.Dodge, stats.Parry, stats.FencingParry, stats.Block, stats.ExtraAttack, stats.ExtraParry, stats.Speed, stats.WeaponMaster, stats.WeaponSkill, dmg, orElse(dtype, stats.DamageType), stats.FollowupDamage, stats.FollowupDamageType, stats.UnnaturallyFragile, stats.Berserk, stats.HighPainThreshold, stats.SupernaturalDurability, stats.InjuryTolerance, stats.AlteredTimeRate, stats.UseRapidStrike, stats.CannotBeParried));
                    setEditing(false);
                    updateTxt(render(dmg));
                    break;
                }
                case 1: {
                    update_1(new Core_Creature(stats.name, stats.pluralName, stats.ST, stats.DX, stats.IQ, stats.HT, stats.HP, stats.DR, stats.Dodge, stats.Parry, stats.FencingParry, stats.Block, stats.ExtraAttack, stats.ExtraParry, stats.Speed, stats.WeaponMaster, stats.WeaponSkill, void 0, stats.DamageType, stats.FollowupDamage, stats.FollowupDamageType, stats.UnnaturallyFragile, stats.Berserk, stats.HighPainThreshold, stats.SupernaturalDurability, stats.InjuryTolerance, stats.AlteredTimeRate, stats.UseRapidStrike, stats.CannotBeParried));
                    setEditing(false);
                    updateTxt("");
                    break;
                }
            }
        }]])))), delay(() => {
            const matchValue_2 = stats.Damage;
            let matchResult_1;
            if (matchValue_2 != null) {
                if (matchValue_2.tag === 0) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 0;
            }
            switch (matchResult_1) {
                case 0: {
                    return empty_1();
                }
                default:
                    return singleton_1(`(${toString(Core_Creature__get_Damage_(stats))})`);
            }
        }));
    })))));
}

export function EditView(editViewInputProps) {
    const dispatch = editViewInputProps.dispatch;
    const db = editViewInputProps.db;
    const name = editViewInputProps.name;
    const patternInput = useFeliz_React__React_useState_Static_1505(defaultArg(tryFind(name, db.catalog), Core_Creature_create_27AED5E3(name)));
    const stats_1 = patternInput[0];
    const setStats = patternInput[1];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(toString_1(stats_1));
    const setTextView = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(false);
    const setTextError = patternInput_2[1];
    const update_1 = (stats_2) => {
        setTextView(toString_1(stats_2));
        setStats(stats_2);
    };
    const editString = (label, hint, tupledArg) => createElement(EditData, {
        propType: ["type", "text"],
        render: toString,
        parser: (txt) => {
            if (String_isntWhitespace(txt)) {
                return txt;
            }
            else {
                return void 0;
            }
        },
        label: label,
        hint: hint,
        value: unwrap(tupledArg[0]),
        update: tupledArg[1],
    });
    const editNumber = (label_1, hint_1, tupledArg_1) => createElement(EditData, {
        propType: ["type", "number"],
        render: toString,
        parser: (input) => {
            let matchValue;
            let outArg = 0;
            matchValue = [tryParse(input, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                outArg = (v | 0);
            })), outArg];
            if (matchValue[0]) {
                return matchValue[1];
            }
            else {
                return void 0;
            }
        },
        label: label_1,
        hint: hint_1,
        value: unwrap(tupledArg_1[0]),
        update: tupledArg_1[1],
    });
    const editNumberNoHint = (label_2, tupledArg_2) => createElement(EditDataNoHint, {
        propType: ["type", "number"],
        render: toString,
        parser: (input_1) => {
            let matchValue_1;
            let outArg_1 = 0;
            matchValue_1 = [tryParse(input_1, 511, false, 32, new FSharpRef(() => outArg_1, (v_1) => {
                outArg_1 = (v_1 | 0);
            })), outArg_1];
            if (matchValue_1[0]) {
                return matchValue_1[1];
            }
            else {
                return void 0;
            }
        },
        label: label_2,
        value: unwrap(tupledArg_2[0]),
        update: tupledArg_2[1],
    });
    const editDamageType = (label_5, defaultOption, tupledArg_7) => createElement(EditDropdown, {
        render: toString,
        parser: (input_4) => {
            let tupledArg_6;
            const matchValue_4 = ParseArgs_Init_E827B83(input_4);
            let matchResult, r_1;
            const activePatternResult_2 = Parser_$007CDamageType$007C_$007C(matchValue_4);
            if (activePatternResult_2 != null) {
                if (((tupledArg_6 = activePatternResult_2[1], $007CEnd$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) {
                    matchResult = 0;
                    r_1 = activePatternResult_2[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return r_1;
                default:
                    return void 0;
            }
        },
        label: label_5,
        defaultOption: unwrap(defaultOption),
        value: unwrap(tupledArg_7[0]),
        options: tupledArg_7[1],
        update: tupledArg_7[2],
    });
    let editBerserkLevel;
    const render_7 = Core_SelfControlLevel_get_toDescription();
    editBerserkLevel = ((label_7) => ((defaultOption_2) => ((tupledArg_9) => createElement(EditDropdown, {
        render: render_7,
        parser: (input_5) => tryFind_1((lvl) => (Core_SelfControlLevel_get_toDescription()(lvl) === input_5), ofArray([new Core_SelfControlLevel(0, []), new Core_SelfControlLevel(1, []), new Core_SelfControlLevel(2, []), new Core_SelfControlLevel(3, []), new Core_SelfControlLevel(4, [])])),
        label: label_7,
        defaultOption: unwrap(defaultOption_2),
        value: unwrap(tupledArg_9[0]),
        options: tupledArg_9[1],
        update: tupledArg_9[2],
    }))));
    const editBool = (label_8, tupledArg_10) => checkbox((arg) => createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(arg)),
    }), label_8, tupledArg_10[0], tupledArg_10[1]);
    return class$0027("editView", (arg_1) => createElement("div", createObj(arg_1)), toList(delay(() => {
        let value_15;
        return append(singleton_1(classP$0027("textview" + (patternInput_2[0] ? " error" : ""), (arg_2) => createElement("input", createObj(arg_2)), ofArray([(value_15 = patternInput_1[0], ["ref", (e) => {
            if (!(e == null) && !equals(e.value, value_15)) {
                e.value = value_15;
            }
        }]), ["onChange", (ev) => {
            let tupledArg_11;
            const input_6 = ev.target.value;
            const matchValue_5 = ParseArgs_Init_E827B83(input_6);
            let matchResult_1, creature;
            const activePatternResult_4 = Parser_$007CCreature$007C_$007C(matchValue_5);
            if (activePatternResult_4 != null) {
                if (((tupledArg_11 = activePatternResult_4[1], $007CEnd$007C_$007C(tupledArg_11[0], tupledArg_11[1]))) != null) {
                    matchResult_1 = 0;
                    creature = activePatternResult_4[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    setTextView(input_6);
                    setTextError(false);
                    setStats(creature);
                    break;
                }
                case 1: {
                    setTextView(input_6);
                    setTextError(true);
                    break;
                }
            }
        }]]))), delay(() => append(singleton_1(editString("Name", "", [stats_1.name, (txt_1) => {
            update_1(new Core_Creature(defaultArg(txt_1, ""), stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
        }])), delay(() => append(singleton_1(editString("Pluralized", stats_1.name + "s", [stats_1.pluralName, (txt_2) => {
            update_1(new Core_Creature(stats_1.name, txt_2, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
        }])), delay(() => append(singleton_1(editNumber("ST", Core_Creature__get_ST_(stats_1), [stats_1.ST, (n_3) => {
            update_1(new Core_Creature(stats_1.name, stats_1.pluralName, n_3, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
        }])), delay(() => append(singleton_1(editNumber("DX", Core_Creature__get_DX_(stats_1), [stats_1.DX, (n_4) => {
            update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, n_4, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
        }])), delay(() => append(singleton_1(editNumber("IQ", Core_Creature__get_IQ_(stats_1), [stats_1.IQ, (n_5) => {
            update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, n_5, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
        }])), delay(() => append(singleton_1(editNumber("HT", Core_Creature__get_HT_(stats_1), [stats_1.HT, (n_6) => {
            update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, n_6, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
        }])), delay(() => append(singleton_1(editNumber("DR", Core_Creature__get_DR_(stats_1), [stats_1.DR, (n_7) => {
            update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, n_7, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
        }])), delay(() => {
            let tupledArg_8;
            return append(singleton_1((tupledArg_8 = [stats_1.InjuryTolerance, ofArray([new Core_InjuryTolerance(0, []), new Core_InjuryTolerance(1, []), new Core_InjuryTolerance(2, [])]), (v_4) => {
                update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, v_4, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
            }], createElement(EditDropdown, {
                render: toString,
                parser: (_arg) => {
                    switch (_arg) {
                        case "Unliving":
                            return new Core_InjuryTolerance(0, []);
                        case "Homogeneous":
                            return new Core_InjuryTolerance(1, []);
                        case "Diffuse":
                            return new Core_InjuryTolerance(2, []);
                        default:
                            return void 0;
                    }
                },
                label: "Injury Tolerance",
                defaultOption: "Normal",
                value: unwrap(tupledArg_8[0]),
                options: tupledArg_8[1],
                update: tupledArg_8[2],
            }))), delay(() => append(singleton_1(editNumber("HP", Core_Creature__get_HP_(stats_1), [stats_1.HP, (n_8) => {
                update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, n_8, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
            }])), delay(() => append(singleton_1(editBool("Unnaturally fragile", [stats_1.UnnaturallyFragile, (b) => {
                update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, b, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
            }])), delay(() => append(singleton_1(editBool("High Pain Threshold", [stats_1.HighPainThreshold, (b_1) => {
                update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, b_1, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
            }])), delay(() => append(singleton_1(editBool("Immune to shock, stun, unconsciousness", [stats_1.SupernaturalDurability, (b_2) => {
                update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, b_2, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
            }])), delay(() => append(singleton_1(editBerserkLevel("Berserk")("")([stats_1.Berserk, ofArray([new Core_SelfControlLevel(0, []), new Core_SelfControlLevel(1, []), new Core_SelfControlLevel(2, []), new Core_SelfControlLevel(3, []), new Core_SelfControlLevel(4, [])]), (v_5) => {
                update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, v_5, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
            }])), delay(() => {
                let hint_2, tupledArg_3;
                return append(singleton_1((hint_2 = Core_Creature__get_Speed_(stats_1), (tupledArg_3 = [stats_1.Speed, (n_9) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, n_9, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }], createElement(EditData, {
                    propType: ["type", "number"],
                    render: (v_2) => toText(interpolate("%.2f%P()", [v_2])),
                    parser: (input_2) => {
                        let matchValue_2;
                        let outArg_2 = 0;
                        matchValue_2 = [tryParse_1(input_2, new FSharpRef(() => outArg_2, (v_3) => {
                            outArg_2 = v_3;
                        })), outArg_2];
                        if (matchValue_2[0]) {
                            return matchValue_2[1];
                        }
                        else {
                            return void 0;
                        }
                    },
                    label: "Speed",
                    hint: hint_2,
                    value: unwrap(tupledArg_3[0]),
                    update: tupledArg_3[1],
                })))), delay(() => append(singleton_1(editNumberNoHint("Parry", [stats_1.Parry, (n_10) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, n_10, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }])), delay(() => append(singleton_1(editBool("Fencing Parry", [stats_1.FencingParry, (b_3) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, b_3, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }])), delay(() => append(singleton_1(editNumber("Dodge", Core_Creature__get_Dodge_(stats_1), [stats_1.Dodge, (n_11) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, n_11, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }])), delay(() => append(singleton_1(editNumberNoHint("Block", [stats_1.Block, (n_12) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, n_12, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }])), delay(() => append(singleton_1(editNumber("Weapon Skill", Core_Creature__get_WeaponSkill_(stats_1), [stats_1.WeaponSkill, (n_13) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, n_13, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }])), delay(() => append(singleton_1(editBool("Weapon Master", [stats_1.WeaponMaster, (b_4) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, b_4, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }])), delay(() => append(singleton_1(createElement(EditDamage, {
                    label: "Damage",
                    stats: stats_1,
                    update: update_1,
                })), delay(() => append(singleton_1(editDamageType("Damage type", "Other", [stats_1.DamageType, ofArray([new Core_DamageType(2, []), new Core_DamageType(0, []), new Core_DamageType(3, []), new Core_DamageType(1, []), new Core_DamageType(4, []), new Core_DamageType(5, [])]), (v_6) => {
                    update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, v_6, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                }])), delay(() => {
                    let tupledArg_5;
                    return append(singleton_1((tupledArg_5 = [stats_1.FollowupDamage, (r_2) => {
                        update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, r_2, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                    }], createElement(EditDataNoHint, {
                        propType: ["type", "text"],
                        render: toString,
                        parser: (input_3) => {
                            let tupledArg_4;
                            const matchValue_3 = ParseArgs_Init_E827B83(input_3);
                            let matchResult_2, r;
                            const activePatternResult = Parser_$007CRoll$007C_$007C(matchValue_3);
                            if (activePatternResult != null) {
                                if (((tupledArg_4 = activePatternResult[1], $007CEnd$007C_$007C(tupledArg_4[0], tupledArg_4[1]))) != null) {
                                    matchResult_2 = 0;
                                    r = activePatternResult[0];
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                            }
                            else {
                                matchResult_2 = 1;
                            }
                            switch (matchResult_2) {
                                case 0:
                                    return r;
                                default:
                                    return void 0;
                            }
                        },
                        label: "Followup damage",
                        value: unwrap(tupledArg_5[0]),
                        update: tupledArg_5[1],
                    }))), delay(() => append((stats_1.FollowupDamage != null) ? singleton_1(editDamageType("Followup type", void 0, [stats_1.FollowupDamageType, ofArray([new Core_DamageType(2, []), new Core_DamageType(0, []), new Core_DamageType(3, []), new Core_DamageType(1, []), new Core_DamageType(4, []), new Core_DamageType(5, [])]), (v_7) => {
                        update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, v_7, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                    }])) : singleton_1(createElement("div", {})), delay(() => append(singleton_1(editBool("Use Rapid Strike", [stats_1.UseRapidStrike, (b_5) => {
                        update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, b_5, stats_1.CannotBeParried));
                    }])), delay(() => append(singleton_1(editBool("Cannot Be Parried", [stats_1.CannotBeParried, (b_6) => {
                        update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, b_6));
                    }])), delay(() => append(singleton_1(editNumber("Extra Attacks", Core_Creature__get_ExtraAttack_(stats_1), [stats_1.ExtraAttack, (n_14) => {
                        update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, n_14, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                    }])), delay(() => append(singleton_1(editNumber("Extra Parries", Core_Creature__get_ExtraParry_(stats_1), [stats_1.ExtraParry, (n_15) => {
                        update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, n_15, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, stats_1.AlteredTimeRate, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                    }])), delay(() => append(singleton_1(editNumber("Altered Time Rate", Core_Creature__get_AlteredTimeRate_(stats_1), [stats_1.AlteredTimeRate, (n_16) => {
                        update_1(new Core_Creature(stats_1.name, stats_1.pluralName, stats_1.ST, stats_1.DX, stats_1.IQ, stats_1.HT, stats_1.HP, stats_1.DR, stats_1.Dodge, stats_1.Parry, stats_1.FencingParry, stats_1.Block, stats_1.ExtraAttack, stats_1.ExtraParry, stats_1.Speed, stats_1.WeaponMaster, stats_1.WeaponSkill, stats_1.Damage, stats_1.DamageType, stats_1.FollowupDamage, stats_1.FollowupDamageType, stats_1.UnnaturallyFragile, stats_1.Berserk, stats_1.HighPainThreshold, stats_1.SupernaturalDurability, stats_1.InjuryTolerance, n_16, stats_1.UseRapidStrike, stats_1.CannotBeParried));
                    }])), delay(() => singleton_1(class$0027("buttons", (arg_3) => createElement("div", createObj(arg_3)), toList(delay(() => {
                        const cancel = (_arg_1) => {
                            dispatch(new Msg(5, [new Page(0, [])]));
                        };
                        const save = (_arg_2) => {
                            dispatch(new Msg(4, [stats_1]));
                            dispatch(new Msg(5, [new Page(0, [])]));
                        };
                        const noSave = isNullOrWhiteSpace(stats_1.name);
                        return append(singleton_1(createElement("button", {
                            children: "Cancel",
                            onClick: cancel,
                        })), delay(() => append(singleton_1(createElement("button", {
                            children: "OK",
                            onClick: save,
                            disabled: noSave,
                        })), delay(() => {
                            const action_1 = (ev_1) => {
                                if (ev_1.key === "Escape") {
                                    ev_1.preventDefault();
                                    cancel();
                                }
                                else if (((ev_1.key === "s") && ev_1.ctrlKey) && !noSave) {
                                    ev_1.preventDefault();
                                    save();
                                }
                            };
                            const options_4 = void 0;
                            const addOptions = useReact_useMemo_10C6A43C(() => Impl_adjustPassive(options_4), [options_4]);
                            const removeOptions = useReact_useMemo_10C6A43C(() => Impl_createRemoveOptions(options_4), [options_4]);
                            const fn = useReact_useMemo_10C6A43C(() => ((arg_5) => {
                                action_1(arg_5);
                            }), [action_1]);
                            useReact_useEffect_Z5ECA432F(useReact_useCallbackRef_7C4B0DD6(() => {
                                if (addOptions == null) {
                                    document.addEventListener("keydown", fn);
                                }
                                else {
                                    const options_1_1 = addOptions;
                                    document.addEventListener("keydown", fn, options_1_1);
                                }
                                return React_createDisposable_3A5B6456(() => {
                                    if (removeOptions == null) {
                                        document.removeEventListener("keydown", fn);
                                    }
                                    else {
                                        const options_2_1 = removeOptions;
                                        document.removeEventListener("keydown", fn, options_2_1);
                                    }
                                });
                            }));
                            return empty_1();
                        }))));
                    }))))))))))))))))));
                }))))))))))))))))));
            }))))))))))));
        }))))))))))))))));
    })));
}

export function ViewCombat(viewCombatInputProps) {
    let children_6, children_2, children, children_4;
    const dispatch = viewCombatInputProps.dispatch;
    const combatLog = viewCombatInputProps.combatLog;
    const setup = viewCombatInputProps.setup;
    const patternInput = useFeliz_React__React_useState_Static_1505(true);
    const showRolls = patternInput[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(last(combatLog)[1]);
    const setCombat = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(0);
    const setCurrentIndex = patternInput_2[1];
    const currentIndex = patternInput_2[0] | 0;
    return class$0027("combat", (arg) => createElement("div", createObj(arg)), [class$0027("statusTable", (arg_1) => createElement("div", createObj(arg_1)), [(children_6 = ofArray([(children_2 = singleton_2((children = ofArray([createElement("th", {
        children: ["Name"],
    }), createElement("th", {
        children: ["HP"],
    }), createElement("th", {
        children: ["Condition"],
    })]), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))), createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    })), (children_4 = toList(delay(() => map((c) => {
        let elems;
        return createElement("tr", createObj(ofArray([["key", c.personalName], ["className", (c.team === 1) ? "teamBlue" : "teamRed"], (elems = [createElement("td", {
            children: [c.personalName],
        }), createElement("td", {
            children: [Combatant__get_CurrentHP_(c)],
        }), createElement("td", createObj(toList(delay(() => {
            if (Combatant__is_Z625EB0E9(c, new Status(4, []))) {
                return append(singleton_1(["className", "statusDead"]), delay(() => singleton_1(["children", "Dead"])));
            }
            else if (Combatant__is_Z625EB0E9(c, new Status(3, []))) {
                return append(singleton_1(["className", "statusDead"]), delay(() => singleton_1(["children", "Unconscious"])));
            }
            else {
                const matchValue = c.statusMods;
                if (isEmpty(matchValue)) {
                    return append(singleton_1(["className", "statusOk"]), delay(() => singleton_1(["children", "OK"])));
                }
                else {
                    const txt = String_join(", ", sort(map_1(toString, List_distinct(matchValue, {
                        Equals: equals,
                        GetHashCode: safeHash,
                    })), {
                        Compare: comparePrimitives,
                    }));
                    return append(singleton_1(["className", "statusDisabled"]), delay(() => singleton_1(["children", txt])));
                }
            }
        }))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
    }, sortBy((c_1) => [c_1.team, c_1.number], FSharpMap__get_Values(patternInput_1[0].combatants), {
        Compare: compareArrays,
    })))), createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    }))]), createElement("table", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    }))]), class$0027("logButtons", (arg_2) => createElement("div", createObj(arg_2)), toList(delay(() => {
        const setIndex = (gotoNearest, newIndex, _arg) => {
            if ((newIndex >= 0) && (newIndex < length(combatLog))) {
                setCurrentIndex(newIndex);
                setCombat(item(newIndex, combatLog)[1]);
                const log = document.getElementsByClassName("logEntries")[0];
                const entry = log.childNodes[newIndex];
                if (gotoNearest) {
                    entry.scrollIntoView({block: 'nearest', inline: 'nearest'});
                }
                else {
                    entry.scrollIntoView({block: 'start', inline: 'nearest'});
                }
            }
        };
        const changeIndex = (delta) => curry3(setIndex)(true)(currentIndex + delta);
        const priorRound = (_arg_1) => {
            const matchValue_1 = tryFindIndexBack((_arg_2) => {
                let matchResult, ix_2;
                if (_arg_2[1][0] != null) {
                    if (_arg_2[1][0].tag === 7) {
                        if (_arg_2[0] < currentIndex) {
                            matchResult = 0;
                            ix_2 = _arg_2[0];
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else if (_arg_2[0] < currentIndex) {
                    matchResult = 0;
                    ix_2 = _arg_2[0];
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return true;
                    default:
                        return false;
                }
            }, mapIndexed(Tuple2_create, combatLog));
            if (matchValue_1 == null) {
                setIndex(false, 0, void 0);
            }
            else {
                setIndex(false, matchValue_1, void 0);
            }
        };
        const nextRound = (_arg_3) => {
            const matchValue_2 = tryFindIndex((_arg_4) => {
                let matchResult_1, ix_5;
                if (_arg_4[1][0] != null) {
                    if (_arg_4[1][0].tag === 7) {
                        if ((currentIndex === 0) ? true : (_arg_4[0] > currentIndex)) {
                            matchResult_1 = 0;
                            ix_5 = _arg_4[0];
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0:
                        return true;
                    default:
                        return false;
                }
            }, mapIndexed(Tuple2_create, combatLog));
            if (matchValue_2 == null) {
                setIndex(false, length(combatLog) - 1, void 0);
            }
            else {
                setIndex(false, matchValue_2, void 0);
            }
        };
        return append(singleton_1(createElement("button", {
            children: "<<",
            onClick: priorRound,
        })), delay(() => append(singleton_1(createElement("button", {
            children: "<",
            onClick: changeIndex(-1),
        })), delay(() => append(singleton_1(createElement("button", {
            children: ">",
            onClick: changeIndex(1),
        })), delay(() => append(singleton_1(createElement("button", {
            children: ">>",
            onClick: nextRound,
        })), delay(() => {
            const action_1 = (ev) => {
                if ((ev.key === ">") ? true : (ev.key === "ArrowRight")) {
                    ev.preventDefault();
                    nextRound();
                }
                else if ((ev.key === "<") ? true : (ev.key === "ArrowLeft")) {
                    ev.preventDefault();
                    priorRound();
                }
                else {
                    switch (ev.key) {
                        case "ArrowDown": {
                            ev.preventDefault();
                            changeIndex(1)();
                            break;
                        }
                        case "ArrowUp": {
                            ev.preventDefault();
                            changeIndex(-1)();
                            break;
                        }
                        default:
                            0;
                    }
                }
            };
            const options_1 = void 0;
            const addOptions = useReact_useMemo_10C6A43C(() => Impl_adjustPassive(options_1), [options_1]);
            const removeOptions = useReact_useMemo_10C6A43C(() => Impl_createRemoveOptions(options_1), [options_1]);
            const fn = useReact_useMemo_10C6A43C(() => ((arg_3) => {
                action_1(arg_3);
            }), [action_1]);
            useReact_useEffect_Z5ECA432F(useReact_useCallbackRef_7C4B0DD6(() => {
                if (addOptions == null) {
                    document.addEventListener("keydown", fn);
                }
                else {
                    const options_1_1 = addOptions;
                    document.addEventListener("keydown", fn, options_1_1);
                }
                return React_createDisposable_3A5B6456(() => {
                    if (removeOptions == null) {
                        document.removeEventListener("keydown", fn);
                    }
                    else {
                        const options_2 = removeOptions;
                        document.removeEventListener("keydown", fn, options_2);
                    }
                });
            }));
            return singleton_1(checkbox((arg_4) => createElement("span", {
                children: Interop_reactApi.Children.toArray(Array.from(arg_4)),
            }), "Show rolls", showRolls, patternInput[1]));
        }))))))));
    }))), class$0027("logEntries", (arg_5) => createElement("div", createObj(arg_5)), toList(delay(() => collect((matchValue_3) => {
        const state = matchValue_3[1][1];
        const ix_7 = matchValue_3[0] | 0;
        const header = (txt_1) => createElement("h3", createObj(toList(delay(() => append(singleton_1(["children", txt_1]), delay(() => append(singleton_1(["onClick", (_arg_5) => {
            setCurrentIndex(ix_7);
            setCombat(state);
        }]), delay(() => ((ix_7 === currentIndex) ? singleton_1(["className", "selected"]) : empty_1())))))))));
        const div = (children_10) => createElement("div", createObj(toList(delay(() => append(singleton_1(["children", Interop_reactApi.Children.toArray(Array.from(children_10))]), delay(() => append(singleton_1(["onClick", (_arg_6) => {
            setCurrentIndex(ix_7);
            setCombat(state);
        }]), delay(() => ((ix_7 === currentIndex) ? singleton_1(["className", "selected"]) : empty_1())))))))));
        const matchValue_4 = matchValue_3[1][0];
        if (matchValue_4 != null) {
            const msg_1 = matchValue_4;
            const viewDetails = (details) => {
                if (showRolls) {
                    return classTxt$0027("details", (arg_6) => createElement("span", createObj(arg_6)), ` ${details}`);
                }
                else {
                    return react.createElement(react.Fragment, {});
                }
            };
            const name_52 = (_arg_7) => {
                switch (_arg_7[0]) {
                    case 1:
                        return classTxt$0027("blueName", (arg_7) => createElement("span", createObj(arg_7)), _arg_7[1]);
                    case 2:
                        return classTxt$0027("redName", (arg_8) => createElement("span", createObj(arg_8)), _arg_7[1]);
                    default:
                        return shouldntHappen(void 0);
                }
            };
            const miss = createElement("img", {
                "aria-label": "Miss",
                src: "img/shield_16x16.png",
            });
            const defended = createElement("img", {
                "aria-label": "Defended",
                src: "img/shield_16x16.png",
            });
            const regularHit = createElement("img", {
                "aria-label": "Hit",
                src: "img/sword_16x16.png",
            });
            const bigHit = createElement("img", {
                "aria-label": "Big Hit",
                src: "img/crossedswords_16x16.png",
            });
            const matchValue_5 = msg_1;
            switch (matchValue_5.tag) {
                case 1:
                    return (matchValue_5.fields[1].defense.tag === 1) ? singleton_1(div(ofArray([defended, name_52(matchValue_5.fields[0].attacker), " attacks ", name_52(matchValue_5.fields[0].target), " who blocks", viewDetails(matchValue_5.fields[2])]))) : ((matchValue_5.fields[1].defense.tag === 2) ? singleton_1(div(ofArray([defended, name_52(matchValue_5.fields[0].attacker), " attacks ", name_52(matchValue_5.fields[0].target), " who dodges", viewDetails(matchValue_5.fields[2])]))) : singleton_1(div(ofArray([defended, name_52(matchValue_5.fields[0].attacker), " attacks ", name_52(matchValue_5.fields[0].target), " who parries", viewDetails(matchValue_5.fields[2])]))));
                case 2:
                    return singleton_1(div(ofArray([miss, name_52(matchValue_5.fields[0].attacker), " misses ", name_52(matchValue_5.fields[0].target), viewDetails(matchValue_5.fields[1])])));
                case 3:
                    return singleton_1(div(ofArray([name_52(matchValue_5.fields[0]), " falls unconscious ", viewDetails(matchValue_5.fields[1])])));
                case 4:
                    return singleton_1(div(ofArray([name_52(matchValue_5.fields[0]), " recovers from stun ", viewDetails(matchValue_5.fields[1])])));
                case 5:
                    return singleton_1(div(ofArray([name_52(matchValue_5.fields[0]), " stands up ", viewDetails(matchValue_5.fields[1])])));
                case 6:
                    return singleton_1(div(ofArray([name_52(matchValue_5.fields[0]), ` ${matchValue_5.fields[1]}`, viewDetails(matchValue_5.fields[2])])));
                case 7:
                    return singleton_1(header(`Round ${matchValue_5.fields[0]} starts`));
                default: {
                    const hit = (verb) => div(ofArray([bigHit, name_52(matchValue_5.fields[0].attacker), ` ${verb} `, name_52(matchValue_5.fields[0].target), ` with a hit for ${matchValue_5.fields[2]} HP`, viewDetails(matchValue_5.fields[4])]));
                    const matchValue_6 = matchValue_5.fields[3];
                    return contains(new Status(4, []), matchValue_6, {
                        Equals: equals,
                        GetHashCode: safeHash,
                    }) ? singleton_1(hit("kills")) : (contains(new Status(3, []), matchValue_6, {
                        Equals: equals,
                        GetHashCode: safeHash,
                    }) ? singleton_1(hit("KOs")) : (contains(new Status(1, []), matchValue_6, {
                        Equals: equals,
                        GetHashCode: safeHash,
                    }) ? singleton_1(hit("stuns")) : (contains(new Status(5, []), matchValue_6, {
                        Equals: equals,
                        GetHashCode: safeHash,
                    }) ? singleton_1(div(ofArray([bigHit, name_52(matchValue_5.fields[0].attacker), " drives ", name_52(matchValue_5.fields[0].target), ` berserk with a hit for ${matchValue_5.fields[2]} HP`, viewDetails(matchValue_5.fields[4])]))) : singleton_1(div(ofArray([regularHit, name_52(matchValue_5.fields[0].attacker), " hits ", name_52(matchValue_5.fields[0].target), ` for ${matchValue_5.fields[2]} HP`, viewDetails(matchValue_5.fields[4])]))))));
                }
            }
        }
        else {
            return singleton_1(header("Combat begins"));
        }
    }, mapIndexed(Tuple2_create, combatLog)))))]);
}

export function ExecuteButton(executeButtonInputProps) {
    const dispatch = executeButtonInputProps.dispatch;
    const model = executeButtonInputProps.model;
    const action_1 = (ev) => {
        if ((ev.key === "Enter") && ev.ctrlKey) {
            ev.preventDefault();
            beginFights(model, dispatch);
        }
    };
    const options_1 = void 0;
    const addOptions = useReact_useMemo_10C6A43C(() => Impl_adjustPassive(options_1), [options_1]);
    const removeOptions = useReact_useMemo_10C6A43C(() => Impl_createRemoveOptions(options_1), [options_1]);
    const fn = useReact_useMemo_10C6A43C(() => ((arg) => {
        action_1(arg);
    }), [action_1]);
    useReact_useEffect_Z5ECA432F(useReact_useCallbackRef_7C4B0DD6(() => {
        if (addOptions == null) {
            document.addEventListener("keydown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("keydown", fn, options_1_1);
        }
        return React_createDisposable_3A5B6456(() => {
            if (removeOptions == null) {
                document.removeEventListener("keydown", fn);
            }
            else {
                const options_2 = removeOptions;
                document.removeEventListener("keydown", fn, options_2);
            }
        });
    }));
    return createElement("button", {
        children: "Execute",
        onClick: (arg30$0040) => {
            thunk2((model_1, dispatch_1) => {
                beginFights(model_1, dispatch_1);
            }, model, dispatch, arg30$0040);
        },
    });
}

export function view(model, dispatch) {
    let elems_1, elems, children_2;
    const matchValue = model.error;
    const matchValue_1 = model.page;
    if (matchValue == null) {
        if (matchValue_1.tag === 1) {
            return createElement(EditView, {
                name: matchValue_1.fields[0],
                db: model.database,
                dispatch: dispatch,
            });
        }
        else if (equals(model.execution, new Awaitable$1(1, []))) {
            return class$0027("slideFromTop", (arg_2) => createElement("div", createObj(arg_2)), [createElement("div", {
                children: ["Executing..."],
            }), class$0027("busy", (arg_3) => createElement("div", createObj(arg_3)), toList(delay(() => collect((matchValue_3) => singleton_1(class$0027("wave", (arg_4) => createElement("div", createObj(arg_4)), [])), rangeDouble(1, 1, 10)))))]);
        }
        else {
            return createElement("div", createObj(ofArray([["className", "homePage"], (elems_1 = [classP$0027("srcLink", (arg_5) => createElement("a", createObj(arg_5)), ofArray([["href", "https://github.com/MaxWilson/CageFight/"], (elems = [createElement("img", {
                src: "img/GitHub_Logo.png",
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])), (children_2 = ofArray([createElement("h1", {
                children: ["Shining Sword Cage Fight!"],
            }), createElement("h3", {
                children: ["For Dungeon Fantasy RPG and GURPS"],
            })]), createElement("div", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            })), class$0027("main", (arg_6) => createElement("div", createObj(arg_6)), toList(delay(() => append(singleton_1(class$0027("fightSetup", (arg_7) => createElement("div", createObj(arg_7)), toList(delay(() => {
                const editLink = (quantity, name_31) => {
                    let q;
                    let patternInput;
                    const creature = FSharpMap__get_Item(model.database.catalog, name_31);
                    patternInput = ((quantity == null) ? ["N", Core_Creature__get_PluralName_(creature)] : ((quantity === 1) ? ["1", creature.name] : ((q = (quantity | 0), [toString(q), Core_Creature__get_PluralName_(creature)]))));
                    const xs_11 = [patternInput[0], classP$0027("editLink", (arg_8) => createElement("a", createObj(arg_8)), ofArray([["children", patternInput[1]], ["onClick", (_arg_1) => {
                        dispatch(new Msg(5, [new Page(1, [name_31])]));
                    }]]))];
                    return react.createElement(react.Fragment, {}, ...xs_11);
                };
                return append(singleton_1(class$0027("specificQuantity", (arg_9) => createElement("div", createObj(arg_9)), toList(delay(() => {
                    let tupledArg_2, monsterDetails, children_6, noMonstersSelectedYet;
                    const changeQuantity = (name_36, delta, f) => (new FightSetup(filter_1((tupledArg) => (tupledArg[0] > 0), map_1((_arg_2) => {
                        if (name_36 === _arg_2[1]) {
                            return [_arg_2[0] + delta, name_36];
                        }
                        else {
                            return _arg_2;
                        }
                    }, f.sideA)), f.sideB));
                    return singleton_1((tupledArg_2 = ["Add", (arg_12) => {
                        let name_37;
                        dispatch(new Msg(2, [(name_37 = arg_12, (fightSetup) => (exists((tupledArg_1) => (name_37 === tupledArg_1[1]), fightSetup.sideA) ? changeQuantity(name_37, 1, fightSetup) : (new FightSetup(append_1(fightSetup.sideA, singleton_2([1, name_37])), fightSetup.sideB))))]));
                    }, new Side(0, []), dispatch], (monsterDetails = ((children_6 = toList(delay(() => {
                        const matchValue_4 = model.fightSetup.sideA;
                        return isEmpty(matchValue_4) ? singleton_1("No creatures selected") : collect((matchValue_5) => {
                            let children_4;
                            const name_38 = matchValue_5[1];
                            return singleton_1((children_4 = ofArray([createElement("button", {
                                children: "+",
                                onClick: (_arg_5) => {
                                    dispatch(new Msg(2, [curry3(changeQuantity)(name_38)(1)]));
                                },
                            }), createElement("button", {
                                children: "-",
                                onClick: (_arg_6) => {
                                    dispatch(new Msg(2, [curry3(changeQuantity)(name_38)(-1)]));
                                },
                            }), editLink(matchValue_5[0], name_38)]), createElement("div", {
                                children: Interop_reactApi.Children.toArray(Array.from(children_4)),
                            })));
                        }, matchValue_4);
                    })), createElement("div", {
                        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
                    }))), (noMonstersSelectedYet = isEmpty(model.fightSetup.sideA), createElement(MonsterPicker, {
                        db: model.database,
                        noMonstersSelectedYet: noMonstersSelectedYet,
                        clickLabel: tupledArg_2[0],
                        onClick: tupledArg_2[1],
                        side: tupledArg_2[2],
                        dispatch: tupledArg_2[3],
                        monsterDetails: monsterDetails,
                    })))));
                })))), delay(() => append(singleton_1("vs."), delay(() => singleton_1(class$0027("calibrated", (arg_13) => createElement("div", createObj(arg_13)), toList(delay(() => {
                    let monsterDetails_2, xs_26, noMonstersSelectedYet_2, monsterDetails_1, xs_19, noMonstersSelectedYet_1;
                    const wrapInDiv = (element) => createElement("div", {
                        children: Interop_reactApi.Children.toArray([element]),
                    });
                    const onClick_1 = (msg) => ["onClick", (_arg_7) => {
                        dispatch(new Msg(2, [msg]));
                    }];
                    const changeMode = (fight) => {
                        let matchValue_6, name_52;
                        return new FightSetup(fight.sideA, (matchValue_6 = fight.sideB, (matchValue_6.tag === 0) ? ((matchValue_6.fields[0] != null) ? ((name_52 = matchValue_6.fields[0], new Opposition(1, [singleton_2([1, name_52])]))) : (new Opposition(1, [empty()]))) : (!isEmpty(matchValue_6.fields[0]) ? (new Opposition(0, [head(matchValue_6.fields[0])[1], void 0, void 0, new DefeatCriteria(0, [])])) : (new Opposition(0, [void 0, void 0, void 0, new DefeatCriteria(0, [])])))));
                    };
                    const matchValue_7 = model.fightSetup.sideB;
                    if (matchValue_7.tag === 0) {
                        const name_64 = matchValue_7.fields[0];
                        const min = matchValue_7.fields[1];
                        const max = matchValue_7.fields[2];
                        const defeatCriteria = matchValue_7.fields[3];
                        return singleton_1((monsterDetails_2 = ((xs_26 = toList(delay(() => append(singleton_1(wrapInDiv(createElement("button", createObj(ofArray([["children", "Find optimal quantity"], onClick_1(changeMode)]))))), delay(() => {
                            let children_12, children_14;
                            const matchValue_10 = name_64;
                            if (matchValue_10 == null) {
                                return singleton_1(createElement("div", {
                                    children: ["No creatures selected"],
                                }));
                            }
                            else {
                                const name_68 = matchValue_10;
                                return singleton_1(class$0027("calibrationRange", (arg_21) => createElement("div", createObj(arg_21)), [(children_12 = ofArray([editLink(void 0, name_68), "should lose", class$0027("calibrationRange", (arg_22) => createElement("span", createObj(arg_22)), toList(delay(() => append(singleton_1(createElement("input", createObj(toList(delay(() => append(singleton_1(["type", "number"]), delay(() => append(singleton_1(["placeholder", toString(defaultArg(min, 50))]), delay(() => append(singleton_1(["onChange", (ev) => {
                                    let v_2;
                                    let matchValue_11;
                                    let outArg = 0;
                                    matchValue_11 = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                                        outArg = (v | 0);
                                    })), outArg];
                                    v_2 = (matchValue_11[0] ? matchValue_11[1] : void 0);
                                    dispatch(new Msg(2, [(fight_1) => (new FightSetup(fight_1.sideA, new Opposition(0, [name_68, v_2, max, defeatCriteria])))]));
                                }]), delay(() => append(singleton_1(["max", 99]), delay(() => {
                                    let value_48;
                                    const matchValue_13 = min;
                                    if (matchValue_13 == null) {
                                        return empty_1();
                                    }
                                    else {
                                        return singleton_1((value_48 = (matchValue_13 | 0), ["ref", (e) => {
                                            if (!(e == null) && !equals(e.value, value_48)) {
                                                e.value = (value_48 | 0);
                                            }
                                        }]));
                                    }
                                }))))))))))))), delay(() => append(singleton_1("% to "), delay(() => append(singleton_1(createElement("input", createObj(toList(delay(() => append(singleton_1(["type", "number"]), delay(() => append(singleton_1(["placeholder", toString(defaultArg(max, 90))]), delay(() => append(singleton_1(["onChange", (ev_1) => {
                                    let v_5;
                                    let matchValue_12;
                                    let outArg_1 = 0;
                                    matchValue_12 = [tryParse(ev_1.target.value, 511, false, 32, new FSharpRef(() => outArg_1, (v_3) => {
                                        outArg_1 = (v_3 | 0);
                                    })), outArg_1];
                                    v_5 = (matchValue_12[0] ? matchValue_12[1] : void 0);
                                    dispatch(new Msg(2, [(fight_2) => (new FightSetup(fight_2.sideA, new Opposition(0, [name_68, min, v_5, defeatCriteria])))]));
                                }]), delay(() => append(singleton_1(["max", 99]), delay(() => {
                                    let value_57;
                                    const matchValue_14 = max;
                                    if (matchValue_14 == null) {
                                        return empty_1();
                                    }
                                    else {
                                        return singleton_1((value_57 = (matchValue_14 | 0), ["ref", (e_1) => {
                                            if (!(e_1 == null) && !equals(e_1.value, value_57)) {
                                                e_1.value = (value_57 | 0);
                                            }
                                        }]));
                                    }
                                }))))))))))))), delay(() => singleton_1("% of the time"))))))))))]), createElement("div", {
                                    children: Interop_reactApi.Children.toArray(Array.from(children_12)),
                                })), (children_14 = toList(delay(() => append(singleton_1("as measured by"), delay(() => singleton_1(createElement("button", {
                                    children: `${(defeatCriteria.tag === 1) ? "Not killing at least one enemy" : ((defeatCriteria.tag === 2) ? "Not killing at least half the enemies" : "Not killing every enemy")}`,
                                    onClick: (_arg_11) => {
                                        const defeatCriteria_1 = (defeatCriteria.tag === 1) ? (new DefeatCriteria(2, [])) : ((defeatCriteria.tag === 2) ? (new DefeatCriteria(0, [])) : (new DefeatCriteria(1, [])));
                                        dispatch(new Msg(2, [(fight_3) => (new FightSetup(fight_3.sideA, new Opposition(0, [name_68, min, max, defeatCriteria_1])))]));
                                    },
                                })))))), createElement("div", {
                                    children: Interop_reactApi.Children.toArray(Array.from(children_14)),
                                }))]));
                            }
                        })))), react.createElement(react.Fragment, {}, ...xs_26))), (noMonstersSelectedYet_2 = (name_64 == null), createElement(MonsterPicker, {
                            db: model.database,
                            noMonstersSelectedYet: noMonstersSelectedYet_2,
                            clickLabel: "Set",
                            onClick: (arg_20) => {
                                dispatch(new Msg(2, [(fightSetup_2) => (new FightSetup(fightSetup_2.sideA, new Opposition(0, [arg_20, min, max, defeatCriteria])))]));
                            },
                            side: new Side(1, []),
                            dispatch: dispatch,
                            monsterDetails: monsterDetails_2,
                        }))));
                    }
                    else {
                        const sideB_1 = matchValue_7.fields[0];
                        const changeQuantity_1 = (name_53, delta_1, f_1) => {
                            let _arg_8;
                            return new FightSetup(f_1.sideA, (_arg_8 = f_1.sideB, (_arg_8.tag === 1) ? (new Opposition(1, [filter_1((tupledArg_3) => (tupledArg_3[0] > 0), map_1((_arg_9) => {
                                if (name_53 === _arg_9[1]) {
                                    return [_arg_9[0] + delta_1, name_53];
                                }
                                else {
                                    return _arg_9;
                                }
                            }, _arg_8.fields[0]))])) : _arg_8));
                        };
                        return singleton_1((monsterDetails_1 = ((xs_19 = toList(delay(() => append(singleton_1(wrapInDiv(createElement("button", createObj(ofArray([["children", "Specific number"], onClick_1(changeMode)]))))), delay(() => {
                            const matchValue_8 = sideB_1;
                            return isEmpty(matchValue_8) ? singleton_1("No creatures selected") : collect((matchValue_9) => {
                                let children_10;
                                const name_57 = matchValue_9[1];
                                return singleton_1((children_10 = ofArray([createElement("button", createObj(ofArray([["children", "+"], onClick_1(curry3(changeQuantity_1)(name_57)(1))]))), createElement("button", createObj(ofArray([["children", "-"], onClick_1(curry3(changeQuantity_1)(name_57)(-1))]))), editLink(matchValue_9[0], name_57)]), createElement("div", {
                                    children: Interop_reactApi.Children.toArray(Array.from(children_10)),
                                })));
                            }, matchValue_8);
                        })))), react.createElement(react.Fragment, {}, ...xs_19))), (noMonstersSelectedYet_1 = isEmpty(sideB_1), createElement(MonsterPicker, {
                            db: model.database,
                            noMonstersSelectedYet: noMonstersSelectedYet_1,
                            clickLabel: "Add",
                            onClick: (arg_17) => {
                                let name_54;
                                dispatch(new Msg(2, [(name_54 = arg_17, (fightSetup_1) => (exists((tupledArg_4) => (name_54 === tupledArg_4[1]), sideB_1) ? changeQuantity_1(name_54, 1, fightSetup_1) : (new FightSetup(fightSetup_1.sideA, new Opposition(1, [append_1(sideB_1, singleton_2([1, name_54]))])))))]));
                            },
                            side: new Side(1, []),
                            dispatch: dispatch,
                            monsterDetails: monsterDetails_1,
                        }))));
                    }
                }))))))));
            })))), delay(() => append(singleton_1(createElement(ExecuteButton, {
                model: model,
                dispatch: dispatch,
            })), delay(() => {
                let matchValue_17;
                const matchValue_15 = model.execution;
                switch (matchValue_15.tag) {
                    case 2: {
                        const setup = matchValue_15.fields[0][0];
                        const db_3 = model.database;
                        const matchValue_16 = matchValue_15.fields[0][1];
                        if (matchValue_16.tag === 0) {
                            const minQuantity = matchValue_16.fields[0];
                            const maxQuantity = matchValue_16.fields[1];
                            let patternInput_1;
                            const matchValue_18 = setup.sideB;
                            let matchResult, max_2, min_2, name_95;
                            if (matchValue_18.tag === 0) {
                                if (matchValue_18.fields[0] != null) {
                                    matchResult = 0;
                                    max_2 = matchValue_18.fields[2];
                                    min_2 = matchValue_18.fields[1];
                                    name_95 = matchValue_18.fields[0];
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0: {
                                    patternInput_1 = [name_95, min_2, max_2];
                                    break;
                                }
                                default:
                                    patternInput_1 = shouldntHappen(void 0);
                            }
                            const name_96 = patternInput_1[0];
                            const min_4 = defaultArg(patternInput_1[1], 50) | 0;
                            const max_4 = defaultArg(patternInput_1[2], 90) | 0;
                            return append(singleton_1(class$0027("statistics", (arg_23) => createElement("div", createObj(arg_23)), toList(delay(() => {
                                let n_5, n_4, m_2, n_3, m_3, n_6;
                                const quantityDescription = (minQuantity == null) ? ((maxQuantity == null) ? (`an unknown number of ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`) : ((n_5 = (maxQuantity | 0), `${n_5} or fewer ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`))) : ((minQuantity === 1) ? ((maxQuantity == null) ? ((n_4 = (minQuantity | 0), `${n_4} or more ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`)) : ((maxQuantity === 1) ? (`1 ${FSharpMap__get_Item(db_3.catalog, name_96).name}`) : ((minQuantity === maxQuantity) ? ((m_2 = (maxQuantity | 0), (n_3 = (minQuantity | 0), `${n_3} ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`))) : ((m_3 = (maxQuantity | 0), (n_6 = (minQuantity | 0), `${n_6} to ${m_3} ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`)))))) : ((maxQuantity == null) ? ((n_4 = (minQuantity | 0), `${n_4} or more ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`)) : ((minQuantity === maxQuantity) ? ((m_2 = (maxQuantity | 0), (n_3 = (minQuantity | 0), `${n_3} ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`))) : ((m_3 = (maxQuantity | 0), (n_6 = (minQuantity | 0), `${n_6} to ${m_3} ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, name_96))}`))))));
                                return singleton_1(createElement("div", {
                                    children: [`${String_oxfordJoin(map_1((_arg_12) => {
                                        if (_arg_12[0] === 1) {
                                            return `1 ${_arg_12[1]}`;
                                        }
                                        else {
                                            return `${_arg_12[0]} ${Core_Creature__get_PluralName_(FSharpMap__get_Item(db_3.catalog, _arg_12[1]))}`;
                                        }
                                    }, setup.sideA))} wins ${min_4}%-${max_4}% of the time against ${quantityDescription}`],
                                }));
                            })))), delay(() => singleton_1(createElement(ViewCombat, {
                                setup: setup,
                                combatLog: matchValue_16.fields[2],
                                dispatch: dispatch,
                            }))));
                        }
                        else {
                            return append((matchValue_17 = matchValue_16.fields[1].victors, isEmpty(matchValue_17) ? singleton_1(createElement("div", {
                                children: ["Everybody dies!"],
                            })) : ((head(matchValue_17) === 1) ? (isEmpty(tail(matchValue_17)) ? singleton_1(createElement("div", {
                                children: ["Team One wins!"],
                            })) : singleton_1(createElement("div", {
                                children: ["Stalemate!"],
                            }))) : ((head(matchValue_17) === 2) ? (isEmpty(tail(matchValue_17)) ? singleton_1(createElement("div", {
                                children: ["Team Two wins!"],
                            })) : singleton_1(createElement("div", {
                                children: ["Stalemate!"],
                            }))) : singleton_1(createElement("div", {
                                children: ["Stalemate!"],
                            }))))), delay(() => singleton_1(createElement(ViewCombat, {
                                setup: setup,
                                combatLog: matchValue_16.fields[0],
                                dispatch: dispatch,
                            }))));
                        }
                    }
                    default: {
                        return empty_1();
                    }
                }
            })))))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
        }
    }
    else {
        const error = matchValue;
        return class$0027("errorMsg", (arg) => createElement("div", createObj(arg)), [createElement("div", {
            children: Interop_reactApi.Children.toArray([error]),
        }), createElement("button", {
            children: "OK",
            onClick: (arg20$0040) => {
                thunk1(dispatch, new Msg(0, []), arg20$0040);
            },
        }), createElement("button", {
            children: "Start over",
            onClick: (_arg) => {
                dispatch(new Msg(0, []));
                dispatch(new Msg(5, [new Page(0, [])]));
            },
        })]);
    }
}

ProgramModule_run(Program_withReactBatched("feliz-app", ProgramModule_withSubscription((m) => singleton_2([empty(), (dispatch_1) => {
    window.onerror = ((msg_1) => {
        debugger;
        if ((toString_1(msg_1).indexOf("SocketProtocolError") >= 0) === false) {
            dispatch_1(new Msg(1, [toText(printf("Error: %A"))(msg_1)]));
        }
    });
    return React_createDisposable_3A5B6456_1(() => {
        window.onerror = ((value) => {
        });
    });
}]), ProgramModule_mkProgram(init, update, view))));

//# sourceMappingURL=App.fs.js.map
